const CENTS = 100;

export function floorDiscountedPrice(price: number, discountPercent: number): number {
    const priceValue = Number(price) || 0;
    const discountValue = Number(discountPercent) || 0;
    const priceCents = Math.round(priceValue * CENTS);
    const payablePercent = CENTS - discountValue;

    return Math.floor((priceCents * payablePercent) / CENTS) / CENTS;
}
